// src/main.jsx
import React from 'react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import { UserProvider } from './context/UserContext';
import { ToastProvider } from './context/ToastContext';
import { ThemeProvider } from './context/ThemeContext';
import { StyleProvider } from './context/StyleContext';
import { I18nProvider } from './context/I18nContext';
import I18nDomTranslator from './i18n/I18nDomTranslator';
import AppDialogHost from './components/ui/AppDialogHost';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <UserProvider>
      <ThemeProvider>
        <StyleProvider>
          <I18nProvider>
            <ToastProvider>
              <BrowserRouter>
                <I18nDomTranslator />
                <App />
                <AppDialogHost />
              </BrowserRouter>
            </ToastProvider>
          </I18nProvider>
        </StyleProvider>
      </ThemeProvider>
    </UserProvider>
  </StrictMode>,
)
